import React from "react";
import { useIntl } from "react-intl";

import { messages } from "./PreProduction.messages";
import styles from "./PreProduction.module.scss";
import { SimpleLayoutView } from "@src/lms/jelly/extensions/layouts/simple/SimpleLayoutView";
import config from "appConfig";
import { useBlocks } from "@jelly/lesson";

interface PreProductions {
  title: string;
}

export const PreProduction: React.FC<PreProductions> = () => {
  const { formatMessage } = useIntl();
  const block = useBlocks();

  return (
    <SimpleLayoutView>
      <div className={styles.PreProduction}>
        <div className={styles.rightComponent}>
          <div className={styles.listWrapper}>
            <div className={styles.row}>
              <div className={styles.column}>
                <img src={`${config.STATIC_ASSETS_URL}/lms/guide/guide04/location.svg`} alt="Image of map with a pin" />
              </div>
              <div className={styles.column}>
                <h4>{formatMessage(messages.G4_P2_S1_L1_Title)}</h4>
                <ul>
                  <li>{formatMessage(messages.G4_P2_S1_L1_Item1)}</li>
                  {/* <li>{formatMessage(messages.G4_P2_S1_L1_Item2)}</li> */}
                </ul>
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.column}>
                <img src={`${config.STATIC_ASSETS_URL}/lms/guide/guide04/script.svg`} alt="Image of map with a pin" />
              </div>
              <div className={styles.column}>
                <h4>{formatMessage(messages.G4_P2_S1_L2_Title)}</h4>
                <ul>
                  <li>{formatMessage(messages.G4_P2_S1_L2_Item1)}</li>
                  <li dangerouslySetInnerHTML={{ __html: formatMessage(messages.G4_P2_S1_L2_Item2) ?? "" }}></li>
                </ul>
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.column}>
                <img src={`${config.STATIC_ASSETS_URL}/lms/guide/guide04/planning.svg`} alt="Image of map with a pin" />
              </div>
              <div className={styles.column}>
                <h4>{formatMessage(messages.G4_P2_S1_L3_Title)}</h4>
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: formatMessage(messages.G4_P2_S1_L3_Item1) ?? "" }}></li>
                  <li>{formatMessage(messages.G4_P2_S1_L3_Item2)}</li>
                </ul>
              </div>
            </div>
          </div>
          <div className={styles.infoBoxWrapper}>
            <block.infoBox text={formatMessage(messages.G4_P2_S1_WildTrackNote)} compact={true} />
          </div>
        </div>
      </div>
    </SimpleLayoutView>
  );
};
